/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect } from 'react';
import { Switch, Route } from 'react-router-dom';
import MainMenu from './MainMenu';
import MbtiIndex from './MBTI';
import PetWorldChristmas from './PetHome/routes/PetWorldPromotionChristmas';
import Tutorial from './Tutorial';
import GameKingIndex from './GameKing';
import Survey from './Survey';
import PetHomeIndex from './PetHome';
import InteriorItemIndex from './InteriorItem';
import RouletteIndex from './Roulette';
import DrawLotsIndex from './DrawLots';
import BingoIndex from './Bingo';
import { useRecoilState } from 'recoil';
import { cdnUrlConfig, serverMode } from './Utils/atoms';
import { settingApi } from './Utils/Api/SettingApi';
import PlayReview from './PlayReview';

const BIGGLZ_EVENT_REFRESH_KEY = 'BIGGLZ_EVENT_REFRESH_TIME';
const REFRESH_SECONDS = 300; //해당 초가 지나면 페이지 새로고침

function App() {
	const [cdnUrl, setCdnUrl] = useRecoilState(cdnUrlConfig);
	const [mode, setMode] = useRecoilState(serverMode);

	useEffect(() => {
		if (cdnUrl === '') {
			settingApi.getCdnUrl().then((res) => {
				const {
					status,
					data: { CDN },
				} = res;
				if (status === 200) {
					setCdnUrl(CDN);
				}
			});
		}

		if (mode === '') {
			// ["TEST" | "REAL"]
			settingApi.getMode().then((res) => {
				const {
					status,
					data: { MODE },
				} = res;
				if (status === 200) {
					setMode(MODE);
				}
			});
		}

		//브라우저 localStorage에 timestamp를 저장하여
		//일정 시간이 지난 후 페이지를 재방문할때 브라우저 새로고침을 실행한다.
		const currentTimeStamp = Math.floor(+new Date() / 1000); // ex) 1672373053
		const savedRefreshTime = localStorage.getItem(BIGGLZ_EVENT_REFRESH_KEY);

		if (savedRefreshTime === null) {
			localStorage.setItem(BIGGLZ_EVENT_REFRESH_KEY, currentTimeStamp);
		} else if (currentTimeStamp - savedRefreshTime > REFRESH_SECONDS) {
			localStorage.setItem(BIGGLZ_EVENT_REFRESH_KEY, currentTimeStamp);
			window.location.reload();
		}
	}, []);

	return (
		<Switch>
			<Route path='/' component={MainMenu} exact />
			<Route path='/petworld-christmas' component={PetWorldChristmas} />
			<Route path='/tutorial' component={Tutorial} />
			<Route path='/survery' component={Survey} />
			<Route path='/pet-home' component={PetHomeIndex} />
			<Route path='/mbti' component={MbtiIndex} />
			<Route path='/game-king' component={GameKingIndex} />
			<Route path='/play-review' component={PlayReview} />
			<Route path='/roulette' component={RouletteIndex} />
			<Route path='/interior-item' component={InteriorItemIndex} />
			<Route path='/interior-item-promotion' component={InteriorItemIndex} />
			<Route path='/drawlots' component={DrawLotsIndex} />
			<Route path='/bingo' component={BingoIndex} />
		</Switch>
	);
}

export default App;
